module.exports = __webpack_public_path__ + "static/speaker1-05d7325eff115d9e6331f73ad0f6ab69.jpg";